import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiService } from "@/services/api/ApiService";

export interface RecommendQuestionsResult {
  questions: string[];
  updatedDocuments: number;
}

/**
 * Recommend questions from a genie's knowledge. The questions are persisted
 * onto the sources' `metadata.answers` server-side for subsequent visits.
 * The picker shows this mutation's returned questions immediately; refetching
 * documents refreshes source associations without delaying the selectable list.
 */
export const useRecommendQuestions = () => {
  const queryClient = useQueryClient();

  return useMutation<RecommendQuestionsResult, Error, string>({
    mutationFn: async (agentId) =>
      ApiService.invoke<RecommendQuestionsResult>({
        resource: "genie-documents",
        action: "recommend-questions",
        data: { agentId },
      }),
    onSuccess: () => {
      // metadata.answers changed on the sources — refresh the document lists
      // the picker reads its suggestions from.
      queryClient.invalidateQueries({ queryKey: ["documents"] });
      queryClient.invalidateQueries({ queryKey: ["documents-infinite"] });
      queryClient.invalidateQueries({ queryKey: ["knowledge-base-docs"] });
    },
  });
};
